import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Fieldset,
  Flex,
  Grid,
  Group,
  Select,
  TextInput,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconArrowBack, IconPrinter } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  repositoryDelivery,
  repositoryMdm,
} from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblWarrantyItem } from "../../../model/TblWarrantyItem";
import {
  getCommuneSelectNew,
  getProvinceSelectNew,
  getTblDmProcessingMethodSelect,
  getTblDmSaleChanelSelect,
} from "../../../service/getSelectApi";
import ItemList from "./ItemList";
import PrinterReturnCustomers from "./PrinterReturnCustomers";
import GoodsReceiptInspectionRecord from "./GoodsReceiptInspectionRecord";
import MaintenanceInspectionRecord from "./MaintenanceInspectionRecord";

interface MeetingAddress {
  province: number | null;
  commune: number | null;
}

const DetailDataView = ({
  id: idProp,
  onClose: onCloseProp,
  actionView: actionViewProp,
}: DetailDataViewProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Khi mở bằng navigate thì id được truyền qua location.state
  const id = idProp ?? (location.state as any)?.id;
  const actionView = actionViewProp ?? "DETAIL";
  // Khi mở ở tab mới (window.open) thì location.state rỗng nên đọc fallback từ query string
  const code =
    (location.state && location.state?.code) ?? searchParams.get("code");
  // Nếu không có onClose (mở bằng route) thì quay lại trang trước
  const onClose = onCloseProp ?? (() => navigate(-1));
  const entity = {
    id: 0,
    custId: 0,
    deliveryId: 0,
    branchId: null,
    inventoryId: null,
    requestStatus: null,
    deliveryDept: null,
    deliveryDate: null,
    custMeeting: null,
    meetingDate: null,
    custPhone: null,
    provinceId: null,
    communeId: null,
    additionalAddress: null,
    meetingAddress: null,
    processingMethod: null,
    processingMethodName: null,
    employeeIncharge: null,
    requestNum: "",
    note: null,
    vendorId: null,
    message: null,
    address: null,
    priorityId: null,
    warrantyStatus: null,
    locationId: null,
    channel: null,
    channelName: null,
    employeeSupport: null,
    content: null,
    noteAssignRequest: null,
    receiveBranch: null,
    assignDate: null,
    empAssign: null,
    idCustomerGroup: null,
    tblWarrantyServiceRequestFormDetailModels: [],
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const [dataWarrantyItem, setDataWarrantyItem] = useState<TblWarrantyItem[]>(
    [],
  );
  const [dataWarrantyItemSubmit, setDataWarrantyItemSubmit] = useState<
    TblWarrantyItem[]
  >([]);
  const [dataTblProcessingMethod, setDataTblProcessingMethod] = useState<
    ComboboxItem[]
  >([]);
  const [dataTblSaleChannel, setDataTblSaleChannel] = useState<ComboboxItem[]>(
    [],
  );
  const [dataWarrantyCustomerGroup, setDataWarrantyCustomerGroup] = useState<
    ComboboxItem[]
  >([]);

  const [createDate, setCreateDate] = useState("");
  const [provinceId, setProvinceId] = useState<string | null>(null);
  const [communeId, setCommuneId] = useState<string | null>(null);
  const [dataMeetingAddress, setDataMeetingAddress] = useState<MeetingAddress>({
    province: null,
    commune: null,
  });
  const [addressBranch, setAddressBranch] = useState<any>({
    addressBranch: "",
    nameBranch: "",
    companyCode: "",
  });
  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataCommuneSelect, setDataCommuneSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataApi, setDataApi] = useState<any>();
  const componentRef = React.useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    pageStyle: `
      @page {
        size:auto;
        margin: 5mm 0;
    }`,
  });

  const componentRefGRIR = React.useRef(null);
  const handlePrintGRIR = useReactToPrint({
    contentRef: componentRefGRIR,
    pageStyle: `
      @page {
        size:auto;
        margin: 5mm 0;
    }`,
  });

  const componentRefMaintenance = React.useRef(null);
  const handlePrintMaintenance = useReactToPrint({
    contentRef: componentRefMaintenance,
    pageStyle: `
      @page {
        size: A4;
        margin: 6mm 0;
    }`,
  });

  const form = useForm<any>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
  });

  const callApiGetData = async () => {
    open();
    let url = "/api/v1/TblWarrantyServiceRequestForm/detailV2";

    if (code) {
      url += `?code=${code}`;
    } else {
      url += `?id=${id}`;
    }

    const callApi = await repositoryMdm.get<MessageResponse<any>>(url);
    if (callApi?.success) {
      const dataApi = callApi?.data;
      if (dataApi !== null) {
        await Promise.all([
          processingMethodSelect(),
          saleChannelSelect(),
          getDataProvinceSelect(),
          getDataWarrantyCustomerGroup(),
        ]);
        form.setValues(dataApi);
        form.resetDirty(dataApi);
        setDataApi(dataApi);
        setCreateDate(dataApi.createDate);
        setProvinceId(dataApi.provinceId?.toString());
        setCommuneId(dataApi.communeId?.toString());
        if (dataApi.attribute6 === "HANG_NGOAI") {
          setDataWarrantyItem(
            dataApi?.getDetailForUpdateWarrantyServiceRequestFormModels,
          );
        }
        setDataMeetingAddress({
          province: form.getValues().provinceId ?? null,
          commune: form.getValues().communeId ?? null,
        });
      }
    }
    close();
  };

  const processingMethodSelect = async () => {
    try {
      const getData = await getTblDmProcessingMethodSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblProcessingMethod(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const getAddressBranch = async () => {
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      `/api/v1/TblDmMasterOrg/get-all`,
    );

    if (res && res.success) {
      const result = res.data.filter(
        (item: any) => Number(item.id) === Number(form.getValues()?.branchId),
      );

      setAddressBranch({
        addressBranch:
          String(result[0].address).length > 52
            ? String(result[0].address)
                .replace(
                  /\b(Phường|phường|Quận|quận|Thành Phố|Thành phố|thành phố)\b/gi,
                  "",
                )
                .replace(/\s+/g, " ")
                .trim()
            : result[0].address,
        nameBranch: result[0].name,
        companyCode: result[0].companyCode,
      });
    }
  };

  const saleChannelSelect = async () => {
    try {
      const getData = await getTblDmSaleChanelSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblSaleChannel(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const getDataWarrantyCustomerGroup = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblWarrantyCustomerGroup/get-all",
    );

    if (res && res?.success) {
      const getData = res.data;
      const filteredData = getData?.filter(
        (item: any) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item: any) => ({
        value: item.value?.toString(),
        label: item.text,
      }));
      setDataWarrantyCustomerGroup(mappedData);
    }
  };

  const getDataProvinceSelect = async () => {
    const getData = await getProvinceSelectNew();
    setDataProvinceSelect(
      getData
        ?.filter((item: any) => item.id != null && item.name != null)
        ?.map((item: any) => ({
          value: String(item.id),
          label: String(item.name),
        })),
    );
  };

  const getDataCommuneSelect = async () => {
    const currentProvince = provinceId || dataMeetingAddress.province;
    if (currentProvince) {
      const getData = await getCommuneSelectNew(String(currentProvince));
      setDataCommuneSelect(
        getData
          ?.filter((item: any) => item.value != null && item.text != null)
          ?.map((item: any) => ({
            value: String(item.value),
            label: String(item.text),
          })),
      );
    }
  };

  useEffect(() => {
    // Mở bằng navigate có thể chỉ truyền code (không có id) -> vẫn phải load được
    if (id || code) {
      callApiGetData();
    } else {
      onClose("");
    }
  }, [id, code]);

  useEffect(() => {
    if (provinceId && provinceId.length > 0) {
      getDataCommuneSelect();
    }
  }, [provinceId]);

  useEffect(() => {
    form.setValues((prev) => ({
      ...prev,
      communeId: Number(dataMeetingAddress.commune),
      provinceId: Number(dataMeetingAddress.province),
    }));
  }, [dataMeetingAddress]);

  useEffect(() => {
    if (form.getValues()?.branchId) {
      getAddressBranch();
    }
  }, [form.getValues()?.branchId]);

  // navigator.onLine

  return (
    <>
      <Box
        component="form"
        mx="auto"
        mt={-7.5}
        p={"0px 10px"}
        style={{ position: "relative" }}
      >
        <Flex justify={"space-between"} align={"center"}>
          <Badge
            variant="gradient"
            gradient={{ from: "blue", to: "cyan", deg: 90 }}
          >
            Chi tiết phiếu tiếp nhận yêu cầu
          </Badge>
          <Group
            justify="space-between"
            align="center"
            style={{
              position: "sticky",
              bottom: 0,
              backgroundColor: "white",
            }}
          >
            <Flex w={"100%"} justify={"flex-end"} gap={"md"}>
              <Button
                type="button"
                color="red"
                loading={visible}
                onClick={() => {
                  onClose("");
                }}
                leftSection={!visible ? <IconArrowBack size={18} /> : undefined}
              >
                Thoát
              </Button>
              <Button
                color="blue"
                onClick={() => handlePrintGRIR()}
                leftSection={<IconPrinter size={18} />}
              >
                In biên bản kiểm tra tiếp nhận sản phẩm
              </Button>
              {/* Biên bản bảo trì chỉ dành cho nhóm khách hàng BHBT (BH bảo trì) */}
              {form.getValues()?.customerGroup === "BHBT" && (
                <Button
                  color="blue"
                  onClick={() => handlePrintMaintenance()}
                  leftSection={<IconPrinter size={18} />}
                >
                  In biên bản bảo trì
                </Button>
              )}
              {form.getValues()?.requestStatus === "TRA_KHACH" ||
              form
                .getValues()
                ?.tblWarrantyServiceRequestFormDetailModels?.some(
                  (item: any) =>
                    item.attribute10 && item.attribute10 !== "NHAP_KHO",
                ) ? (
                <Button
                  color="blue"
                  onClick={() => handlePrint()}
                  leftSection={<IconPrinter size={18} />}
                >
                  In phiếu xuất trả khách
                </Button>
              ) : (
                <></>
              )}
            </Flex>
          </Group>
        </Flex>
        <Grid>
          <Grid.Col span={{ base: 12, md: 12, lg: 5.25 }}>
            <Fieldset legend="Thông tin yêu cầu xử lý">
              <Grid>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <TextInput
                    label="Chi nhánh xử lý yêu cầu"
                    placeholder="Chọn chi nhánh xử lý yêu cầu"
                    value={addressBranch?.nameBranch || ""}
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <DateTimePicker
                    label="Ngày tiếp nhận"
                    readOnly
                    locale="vi"
                    valueFormat="DD-MM-YYYY hh:mm A"
                    value={createDate ? new Date(createDate ?? "") : null}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <TextInput
                    label="Người tiếp nhận yêu cầu"
                    readOnly
                    {...form.getInputProps("createByName")}
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <TextInput
                    label="Mã phiếu tiếp nhận yêu cầu"
                    readOnly
                    {...form.getInputProps("requestNum")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <Select
                    label="Kênh tiếp nhận"
                    placeholder="Chọn kênh tiếp nhận"
                    data={dataTblSaleChannel}
                    value={form.getValues().channel?.toString() ?? null}
                    {...form.getInputProps("channel")}
                    comboboxProps={{ width: 200 }}
                    readOnly
                    rightSection={" "}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <Select
                    label="Hình thức xử lý"
                    placeholder="Chọn hình thức xử lý"
                    data={dataTblProcessingMethod}
                    value={form.getValues().processingMethod?.toString() ?? ""}
                    {...form.getInputProps("processingMethod")}
                    readOnly
                    rightSection={" "}
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <TextInput
                    label="Số phiếu tiếp nhận yêu cầu"
                    readOnly
                    {...form.getInputProps("attribute10")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <Select
                    label="Nhóm khách hàng"
                    placeholder="Nhập nhóm khách hàng"
                    data={dataWarrantyCustomerGroup}
                    value={form.getValues().customerGroup?.toString() ?? null}
                    {...form.getInputProps("customerGroup")}
                    readOnly
                    rightSection={" "}
                  />
                </Grid.Col>
              </Grid>
            </Fieldset>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 12, lg: 6.75 }}>
            <Fieldset legend="Thông tin khách hàng hẹn gặp">
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <TextInput
                    label="Người hẹn gặp"
                    placeholder={"Nhập người hẹn gặp"}
                    {...form.getInputProps("custMeeting")}
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <TextInput
                    label="Số điện thoại"
                    placeholder={"Nhập số điện thoại"}
                    {...form.getInputProps("custPhone")}
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <DateTimePicker
                    label="Ngày hẹn gặp"
                    placeholder="Nhập ngày hẹn gặp"
                    locale="vi"
                    valueFormat="DD-MM-YYYY hh:mm A"
                    value={
                      form.getValues().meetingDate
                        ? new Date(form.getValues().meetingDate ?? "")
                        : null
                    }
                    readOnly
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Select
                    label="Tỉnh/TP"
                    placeholder="Nhập tỉnh/thành phố"
                    data={dataProvinceSelect}
                    value={
                      form.getValues().provinceId
                        ? form.getValues().provinceId?.toString()
                        : null
                    }
                    nothingFoundMessage="Không tìm thấy dữ liệu !"
                    {...form.getInputProps("provinceId")}
                    readOnly
                    rightSection={" "}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Select
                    label="Phường/Xã"
                    placeholder="Nhập phường/xã"
                    data={dataCommuneSelect}
                    nothingFoundMessage="Không tìm thấy dữ liệu !"
                    {...form.getInputProps("communeId")}
                    value={
                      form.getValues().communeId
                        ? form.getValues().communeId?.toString()
                        : null
                    }
                    readOnly
                    rightSection={" "}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <TextInput
                    label="Địa chỉ cụ thể"
                    placeholder="Nhập địa chỉ cụ thể"
                    {...form.getInputProps("additionalAddress")}
                    readOnly
                    rightSection={" "}
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={12}>
                  <TextInput
                    label="Nội dung"
                    placeholder={"Nhập nội dung"}
                    {...form.getInputProps("content")}
                    readOnly
                  />
                </Grid.Col>
              </Grid>
            </Fieldset>
          </Grid.Col>

          <Grid.Col span={{ xs: 12, sm: 12, md: 12, lg: 12 }} px={0}>
            <ItemList
              serviceType={
                form.getValues().tblWarrantyServiceRequestFormDetailModels
              }
              onSelect={setDataWarrantyItemSubmit}
              dataItem={
                form.getValues().tblWarrantyServiceRequestFormDetailModels
              }
              onDelete={setDataWarrantyItem}
              actionView={actionView}
              typeProduct={form.getValues()?.attribute6}
            />
          </Grid.Col>
        </Grid>
      </Box>
      <Box display={"none"}>
        <PrinterReturnCustomers
          innerRef={componentRef}
          dataPrint={{
            ...form.getValues(),
            ...addressBranch,
          }}
          dataPYCXL={form.getValues()}
          isCheck={false}
        />
      </Box>
      <Box display={"none"}>
        <GoodsReceiptInspectionRecord
          innerRef={componentRefGRIR}
          dataPrint={{
            ...form.getValues(),
            ...addressBranch,
          }}
          viewPrint={"PYCXL"}
        />
      </Box>
      <Box display={"none"}>
        <MaintenanceInspectionRecord
          innerRef={componentRefMaintenance}
          dataPrint={{
            ...form.getValues(),
            ...addressBranch,
          }}
        />
      </Box>
    </>
  );
};

export default DetailDataView;

type DetailDataViewProps = {
  id?: string | number;
  onClose?: any;
  actionView?: any;
};
